import React from 'react';
import { keyframes, SxProps, Theme } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

// Define the pulse animation - exported for direct use in other components
export const pulse = keyframes`
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

interface PulsingIconProps {
  IconComponent: SvgIconComponent;
  size?: number | string;
  color?: string;
  duration?: number;
  sx?: SxProps<Theme>;
}

/**
 * A reusable pulsing icon component that provides a subtle animation effect
 */
const PulsingIcon: React.FC<PulsingIconProps> = ({ 
  IconComponent, 
  size = 24, 
  color,
  duration = 2,
  sx = {}
}) => {
  return (
    <IconComponent 
      sx={{ 
        fontSize: size, 
        color: color,
        animation: `${pulse} ${duration}s infinite ease-in-out`,
        ...sx
      }} 
    />
  );
};

export default PulsingIcon;
